module.exports = __webpack_public_path__ + "img/wz-3-4.d6710f63.jpg";